module.exports = __webpack_public_path__ + "img/nu.9deebec.svg";